export default __webpack_public_path__ + "static/media/app-competidores.41a4bac4.jpeg";